/*
Created request Reducer to save questionnaire evaluation data
 */
export const questionnaireEvaluationOverrideScoreRequestReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { isScoreOverrideSuccess: false });
};
//# sourceMappingURL=questionnaireEvaluationOverrideScoreRequestReducer.js.map